import { render, staticRenderFns } from "./DrillList.vue?vue&type=template&id=5dc2dfd8&"
import script from "./DrillList.vue?vue&type=script&lang=ts&"
export * from "./DrillList.vue?vue&type=script&lang=ts&"
import style0 from "./DrillList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DrillList.vue"
export default component.exports